import AddressClient from "@/components/modules/account/address-client";

type AccountAddressProps = {
  resolution: Resolution;
};

const AccountAddress = ({ resolution }: AccountAddressProps) => {
  return <AddressClient locale={resolution?.locale} />;
};

export default AccountAddress;
